import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { generatePath, useNavigate } from "react-router-dom";

import { Button, Grid, Stack, Typography } from "@mui/material";
import { ArrowBack, AttachFile, CreateOutlined } from "@mui/icons-material";

import insurerUserService from "../../../../../services/insurerUserService";
import { AdminRoutesConfig, CommonRoutesConfig } from "../../../../RoutesConfig";
import CertificatesHistory from "../../../../shared/CertificatesHistory";
import SectionPreview from "../../../../../common/components/SectionPreview";
import { translate } from "../../../../../common/utils/formatters";
import { InsurerUserPreviewDto } from "../../../../../interfaces/admin/InsurerUser";

export default function Preview() {
  const { id: paramsId } = useParams();
  const insurerUserId: number = parseInt(paramsId as string);
  const navigate = useNavigate();
  const [insurerUser, setInsurerUser] = useState<InsurerUserPreviewDto>();

  useEffect(() => {
    if (isNaN(insurerUserId)) {
      navigate(CommonRoutesConfig.NotFound.Path, { replace: true });
    }

    (async () => {
      await insurerUserService
        .getInsurerUserAsync(insurerUserId)
        .then(({ data: insurerUser }) => setInsurerUser(insurerUser));
    })();
  }, []);

  const handleEdit = () => {
    navigate(generatePath(AdminRoutesConfig.InsurerUser.Edit.Path, { id: insurerUserId.toString() }));
  };

  return (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between">
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Назад
        </Button>
        <Stack direction="row" spacing={1}>
          <Button startIcon={<CreateOutlined />} onClick={() => handleEdit()}>
            Редактирай
          </Button>
        </Stack>
      </Stack>
      <Stack spacing={3}>
        <SectionPreview title="Данни за застр. дружество">
          <Stack spacing={3}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Typography>Застр. дружество</Typography>
                <Typography>
                  <strong>{insurerUser?.insurer.name}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography>Клон на застр. дружество</Typography>
                <Typography>
                  <strong>{insurerUser?.insurerBranch.name}</strong>
                </Typography>
              </Grid>
            </Grid>
          </Stack>
        </SectionPreview>
        <SectionPreview title="Лични данни">
          <Stack>
            <Typography>Име</Typography>
            <Typography>
              <strong>{insurerUser?.name}</strong>
            </Typography>
          </Stack>
        </SectionPreview>
        <SectionPreview title="Потребителски данни">
          <Stack spacing={3}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Typography>SHA-1 на публичния ключ (на електронния подпис)</Typography>
                <Typography>
                  <strong>{insurerUser?.thumbprint}</strong>
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography>Активен</Typography>
                <Typography>
                  <strong>{translate(!!insurerUser?.isActive)}</strong>
                </Typography>
              </Grid>
            </Grid>
            {insurerUser?.hasCertificateContent && (
              <Grid item xs={12} md={6}>
                <Button
                  startIcon={<AttachFile />}
                  variant="outlined"
                  href={`${process.env.REACT_APP_API_URL}/user/download/certificate/${insurerUser?.thumbprint}`}
                >
                  Изтегли сертификат
                </Button>
              </Grid>
            )}
          </Stack>
        </SectionPreview>
        <CertificatesHistory certificates={insurerUser?.certificates} />
      </Stack>
    </Stack>
  );
}
